import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../auth/AuthContext";
import { apiClient, formatApiErrorDetail } from "../lib/api";

export default function CompleteProfilePage() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    organisation: user?.organisation || "",
    designation: user?.designation || "",
    country: user?.country || "",
  });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSaving(true);
    try {
      await apiClient.put("/auth/profile", form);
      await refresh();
      navigate("/me", { replace: true });
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="complete-profile-page" className="mx-auto w-full max-w-xl py-10">
      <Card className="card-elevated">
        <CardHeader>
          <CardTitle className="text-xl font-semibold text-[#361a54]">Complete your profile</CardTitle>
          <CardDescription>Please share a few details so we can tailor the learning experience.</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={submit} className="grid gap-3">
            <div className="space-y-1">
              <Label htmlFor="organisation">Organisation</Label>
              <Input id="organisation" required value={form.organisation} onChange={(e) => setForm({ ...form, organisation: e.target.value })} data-testid="complete-organisation-input" />
            </div>
            <div className="space-y-1">
              <Label htmlFor="designation">Designation</Label>
              <Input id="designation" value={form.designation} onChange={(e) => setForm({ ...form, designation: e.target.value })} data-testid="complete-designation-input" />
            </div>
            <div className="space-y-1">
              <Label htmlFor="country">Country</Label>
              <Input id="country" required value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} data-testid="complete-country-input" />
            </div>
            {error && <p className="text-sm text-red-700" data-testid="complete-error">{error}</p>}
            <Button type="submit" className="bg-[#361a54] text-white hover:bg-[#2a1443]" disabled={saving} data-testid="complete-submit-btn">
              {saving ? "Saving…" : "Save and continue"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
